/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const GridReportService = {
    dataSourceConfig(url, params) {
        return ApiService.createDataSource(url, params);
    },
    async getReportData(params) {
        return await ApiService.oDataGet(params);
    },
    async requestData(params) {
        return await ApiService.oDataGet(params);
    }
};

export { GridReportService };
